// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toggle-module__font-s-10___Le7nW {
  font-size: 10px !important;
}

.Toggle-module__font-s-12___vxstX {
  font-size: 12px !important;
}

.Toggle-module__font-s-13___CThxk {
  font-size: 13px !important;
}

.Toggle-module__font-s-14___h83kj {
  font-size: 14px !important;
}

.Toggle-module__font-s-15___PlKJ9 {
  font-size: 15px !important;
}

.Toggle-module__font-s-16___Iz7vV {
  font-size: 16px !important;
}

.Toggle-module__font-s-18___cqcHW {
  font-size: 18px !important;
}

.Toggle-module__font-s-20___q5uxa {
  font-size: 20px !important;
}

.Toggle-module__font-s-22___F7fes {
  font-size: 22px !important;
}

.Toggle-module__font-s-28___Ul1g2 {
  font-size: 28px !important;
}

.Toggle-module__font-w-400___bvFAW {
  font-weight: 400 !important;
}

.Toggle-module__font-w-500___ANR97 {
  font-weight: 500 !important;
}

.Toggle-module__font-w-600___w0H0V {
  font-weight: 600 !important;
}

.Toggle-module__font-w-700___GuOX3 {
  font-weight: 700 !important;
}

.Toggle-module__p-5___bElxc {
  padding: 5px !important;
}

.Toggle-module__p-12___utceG {
  padding: 12px !important;
}

.Toggle-module__p-16___pp3J5 {
  padding: 16px !important;
}

.Toggle-module__p-30___ura9N {
  padding: 30px !important;
}

.Toggle-module__p-b-0___fOkDD {
  padding-bottom: 0 !important;
}

.Toggle-module__p-b-5___U1WJv {
  padding-bottom: 5px !important;
}

.Toggle-module__p-b-10___cu6ux {
  padding-bottom: 10px !important;
}

.Toggle-module__p-b-12___hlgkc {
  padding-bottom: 12px !important;
}

.Toggle-module__p-b-16___es_tH {
  padding-bottom: 16px !important;
}

.Toggle-module__p-b-18___cw0GX {
  padding-bottom: 18px !important;
}

.Toggle-module__p-b-20___VQq19 {
  padding-bottom: 20px !important;
}

.Toggle-module__p-b-25___dy7Re {
  padding-bottom: 25px !important;
}

.Toggle-module__p-b-30___seXm3 {
  padding-bottom: 30px !important;
}

.Toggle-module__p-b-50___rYEXp {
  padding-bottom: 50px !important;
}

.Toggle-module__p-t-0___VFs8l {
  padding-top: 0 !important;
}

.Toggle-module__p-t-12___gAQ6H {
  padding-top: 12px !important;
}

.Toggle-module__p-t-16____QPa9 {
  padding-top: 16px !important;
}

.Toggle-module__p-t-18___Bxxy6 {
  padding-top: 18px !important;
}

.Toggle-module__p-t-20___SfsSk {
  padding-top: 20px !important;
}

.Toggle-module__p-t-30___DlkPV {
  padding-top: 30px !important;
}

.Toggle-module__p-t-40___X1RhJ {
  padding-top: 40px !important;
}

.Toggle-module__p-t-50___o1A4X {
  padding-top: 50px !important;
}

.Toggle-module__p-l-20___m4JHU {
  padding-left: 20px !important;
}

.Toggle-module__p-l-30___eTUxK {
  padding-left: 30px !important;
}

.Toggle-module__p-l-40___Xd4uV {
  padding-left: 40px !important;
}

.Toggle-module__p-r-16___Y7O4J {
  padding-right: 16px !important;
}

.Toggle-module__p-r-20___hKVlB {
  padding-right: 20px !important;
}

.Toggle-module__p-r-30___cYkmP {
  padding-right: 30px !important;
}

.Toggle-module__p-r-50___In3dU {
  padding-right: 50px !important;
}

.Toggle-module__p-r-60___UhoHj {
  padding-right: 60px !important;
}

.Toggle-module__m-b-1___Yg_Pg {
  margin-bottom: 1px !important;
}

.Toggle-module__m-b-2___X062S {
  margin-bottom: 2px !important;
}

.Toggle-module__m-b-6___Gv0Qi {
  margin-bottom: 6px !important;
}

.Toggle-module__m-b-8___mKuC3 {
  margin-bottom: 8px !important;
}

.Toggle-module__m-b-10___bHhPx {
  margin-bottom: 10px !important;
}

.Toggle-module__m-b-14___QZY99 {
  margin-bottom: 14px !important;
}

.Toggle-module__m-b-16___m969T {
  margin-bottom: 16px !important;
}

.Toggle-module__m-b-20___sUNTm {
  margin-bottom: 20px !important;
}

.Toggle-module__m-b-22___pdwGn {
  margin-bottom: 22px !important;
}

.Toggle-module__m-b-24___S1KTn {
  margin-bottom: 24px !important;
}

.Toggle-module__m-b-30___JZqL7 {
  margin-bottom: 30px !important;
}

.Toggle-module__m-b-32___DzFb9 {
  margin-bottom: 32px !important;
}

.Toggle-module__m-b-40___DZpzt {
  margin-bottom: 40px !important;
}

.Toggle-module__m-t-2___FZtJj {
  margin-top: 2px !important;
}

.Toggle-module__m-t-3___d9PGh {
  margin-top: 3px !important;
}

.Toggle-module__m-t-4___pNeCc {
  margin-top: 4px !important;
}

.Toggle-module__m-t-5___ywVOq {
  margin-top: 5px !important;
}

.Toggle-module__m-t-8___vPMqz {
  margin-top: 8px !important;
}

.Toggle-module__m-t-10___ln6it {
  margin-top: 10px !important;
}

.Toggle-module__m-t-15___zsdtD {
  margin-top: 15px !important;
}

.Toggle-module__m-t-16___dWpYO {
  margin-top: 16px !important;
}

.Toggle-module__m-t-20___VTQ5L {
  margin-top: 20px !important;
}

.Toggle-module__m-t-22___jfxZG {
  margin-top: 22px !important;
}

.Toggle-module__m-t-30___PnoX1 {
  margin-top: 30px !important;
}

.Toggle-module__m-t-32___zruil {
  margin-top: 32px !important;
}

.Toggle-module__m-l-auto___xP1TU {
  margin-left: auto !important;
}

.Toggle-module__m-l-4___iIC6Z {
  margin-left: 4px !important;
}

.Toggle-module__m-l-5___EdmJW {
  margin-left: 5px !important;
}

.Toggle-module__m-l-6___dalWi {
  margin-left: 6px !important;
}

.Toggle-module__m-l-8____cISB {
  margin-left: 8px !important;
}

.Toggle-module__m-l-10___ZFsvg {
  margin-left: 10px !important;
}

.Toggle-module__m-l-16___ZRQRI {
  margin-left: 16px !important;
}

.Toggle-module__m-l-20___gWdkC {
  margin-left: 20px !important;
}

.Toggle-module__m-l-24___e_s9D {
  margin-left: 24px !important;
}

.Toggle-module__m-l-30___XFQpW {
  margin-left: 30px !important;
}

.Toggle-module__m-l-35___LQG0A {
  margin-left: 35px !important;
}

.Toggle-module__m-l-40___wWmot {
  margin-left: 40px !important;
}

.Toggle-module__m-r-8___Kk1lM {
  margin-right: 8px !important;
}

.Toggle-module__m-r-10___ezhHo {
  margin-right: 10px !important;
}

.Toggle-module__m-r-16___xgh_e {
  margin-right: 16px !important;
}

.Toggle-module__m-r-20___OEnNc {
  margin-right: 20px !important;
}

.Toggle-module__m-r-24___pnT_O {
  margin-right: 24px !important;
}

.Toggle-module__m-r-30____6YtL {
  margin-right: 30px !important;
}

.Toggle-module__m-r-40___UfYCQ {
  margin-right: 40px !important;
}

.Toggle-module__border-r-3___kysXw {
  border-radius: 3px !important;
}

.Toggle-module__border-r-4___Ew85T {
  border-radius: 4px !important;
}

.Toggle-module__border-r-6___WuGKL {
  border-radius: 6px !important;
}

.Toggle-module__border-r-10____cou_ {
  border-radius: 10px !important;
}

.Toggle-module__border-r-12___oMxfH {
  border-radius: 12px !important;
}

.Toggle-module__border-r-16___PCmtx {
  border-radius: 16px !important;
}

.Toggle-module__border-r-50___ND1ZC {
  border-radius: 50% !important;
}

.Toggle-module__primary-border___aoRw9 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Toggle-module__primary-border-b___GKOHz {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Toggle-module__primary-border-t___eSEJD {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Toggle-module__primary-border-l___pEcmj {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Toggle-module__primary-border-r___z4ZxM {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Toggle-module__secondary-border___Z3ldy {
  border: 1px solid #637768;
}

.Toggle-module__secondary-border-b___EW9Gy {
  border-bottom: 1px solid #637768;
}

.Toggle-module__secondary-border-t___GH1on {
  border-top: 1px solid #637768;
}

.Toggle-module__secondary-border-l___OTB8w {
  border-left: 1px solid #637768;
}

.Toggle-module__secondary-border-r___jC2rO {
  border-right: 1px solid #637768;
}

.Toggle-module__gap-0___OY0RS {
  gap: 0 !important;
}

.Toggle-module__gap-2___rlLrM {
  gap: 2px !important;
}

.Toggle-module__gap-4___ZJFzy {
  gap: 4px !important;
}

.Toggle-module__gap-5___baqPM {
  gap: 5px !important;
}

.Toggle-module__gap-6___gYOp4 {
  gap: 6px !important;
}

.Toggle-module__gap-8___a12cl {
  gap: 8px !important;
}

.Toggle-module__gap-10____lBMv {
  gap: 10px !important;
}

.Toggle-module__gap-12___BHsGw {
  gap: 12px !important;
}

.Toggle-module__gap-14___vbP7m {
  gap: 14px !important;
}

.Toggle-module__gap-16___mvWGv {
  gap: 16px !important;
}

.Toggle-module__gap-18___nbpyr {
  gap: 18px !important;
}

.Toggle-module__gap-20___hRkp2 {
  gap: 20px !important;
}

.Toggle-module__gap-24___OlQtW {
  gap: 24px !important;
}

.Toggle-module__gap-26____yiiE {
  gap: 26px !important;
}

.Toggle-module__gap-30___vkTzm {
  gap: 30px !important;
}

.Toggle-module__gap-32___VhNZj {
  gap: 32px !important;
}

.Toggle-module__gap-40___HYSMP {
  gap: 40px !important;
}

.Toggle-module__gap-50___Y8p88 {
  gap: 50px !important;
}

.Toggle-module__flex-1____nqaV {
  flex: 1;
}

.Toggle-module__flex-none___MncPn {
  flex: none !important;
}

.Toggle-module__flex-column____S2pi {
  display: flex;
  flex-direction: column !important;
}

.Toggle-module__flex-row___Ht28M {
  display: flex;
  flex-direction: row !important;
}

.Toggle-module__vertically-centered___SFxbV {
  display: flex;
  align-items: center !important;
}

.Toggle-module__horizontally-centered___UugwM {
  display: flex;
  justify-content: center !important;
}

.Toggle-module__horizontally-end___qku_8 {
  display: flex;
  justify-content: end !important;
}

.Toggle-module__vertically-start___o003d {
  display: flex;
  align-items: start !important;
}

.Toggle-module__space-between___ErWR9 {
  display: flex;
  justify-content: space-between !important;
}

.Toggle-module__flex-wrap___4OvI4 {
  flex-wrap: wrap !important;
}

.Toggle-module__height-100___AwQzE {
  height: 100%;
}

.Toggle-module__width-50___a96jM {
  width: 50% !important;
}

.Toggle-module__width-100___BvR2U {
  width: 100%;
}

.Toggle-module__cursor-pointer___BjJqB {
  cursor: pointer;
}

.Toggle-module__cursor-not-allowed___xzx9e {
  cursor: not-allowed !important;
}

.Toggle-module__absolute-centered___EUiCK {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Toggle-module__absolute___Ogcik {
  position: absolute;
}

.Toggle-module__relative___mk108 {
  position: relative;
}

.Toggle-module__fixed___BG8EP {
  position: fixed;
}

.Toggle-module__visible___ZATHy {
  opacity: 1;
}

.Toggle-module__invisible___eys89 {
  opacity: 0;
}

.Toggle-module__col-90___EoiAR {
  width: 90% !important;
}

.Toggle-module__col-auto___lEI55 {
  width: auto !important;
}

.Toggle-module__medical-tabs___ITle8 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Toggle-module__medical-table-new___KgcIC {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Toggle-module__medical-table-new___KgcIC:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Toggle-module__medical-table-new___KgcIC::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Toggle-module__medical-table-new___KgcIC::-webkit-scrollbar-track {
  display: none;
}
.Toggle-module__medical-table-new___KgcIC.Toggle-module__no-pagination___GI39W {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Toggle-module__medical-table-new___KgcIC.Toggle-module__no-pagination___GI39W:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Toggle-module__medical-table-new___KgcIC.Toggle-module__no-pagination___GI39W::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Toggle-module__medical-table-new___KgcIC.Toggle-module__no-pagination___GI39W::-webkit-scrollbar-track {
  display: none;
}

.Toggle-module__medical-table-empty___oVW8s {
  padding: 14px 40px !important;
}

.Toggle-module__icon-btn___j8_V_ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Toggle-module__search-icon___K34C7 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Toggle-module__disable-select___yNGaV {
  user-select: none;
}

.Toggle-module__break-word___bS41Q {
  word-break: break-word;
}

.Toggle-module__popup-clear-btn___U4BiZ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Toggle-module__scroll-m-b-20___skioI {
  scroll-margin-bottom: 20px;
}

.Toggle-module__container___SvOpR {
  border: 1px solid #859989;
  align-self: baseline;
  overflow: hidden;
  display: flex;
  width: 100%;
}
.Toggle-module__container___SvOpR .Toggle-module__option___BXq3o {
  flex: 1;
  padding: 10px;
  text-align: center;
  color: #375844;
}
.Toggle-module__container___SvOpR .Toggle-module__option___BXq3o.Toggle-module__small___PtjgC {
  font-size: 12px;
  padding: 5px 10px;
}
.Toggle-module__container___SvOpR .Toggle-module__option___BXq3o:not(:last-child) {
  border-right: 1px solid #859989;
}
.Toggle-module__container___SvOpR .Toggle-module__option___BXq3o.Toggle-module__selected___K1v1C {
  background-color: #f1f6f2;
}
.Toggle-module__container___SvOpR .Toggle-module__option___BXq3o.Toggle-module__disabled___y4P1T {
  color: #e0e0e0;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Toggle/Toggle.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AA8pBF;AA5pBE;EACE,OAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AA8pBJ;AA5pBI;EACE,eAAA;EACA,iBAAA;AA8pBN;AA3pBI;EACE,+BAAA;AA6pBN;AA1pBI;EACE,yBAAA;AA4pBN;AAzpBI;EACE,cAAA;EACA,mBAAA;AA2pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  border: 1px solid get-color(greenNew, medium);\n  align-self: baseline;\n  overflow: hidden;\n  display: flex;\n  width: 100%;\n\n  .option {\n    flex: 1;\n    padding: 10px;\n    text-align: center;\n    color: get-color(greenNew, dark);\n\n    &.small {\n      font-size: 12px;\n      padding: 5px 10px;\n    }\n\n    &:not(:last-child) {\n      border-right: 1px solid get-color(greenNew, medium);\n    }\n\n    &.selected {\n      background-color: get-color(greenNew, ultra-light);\n    }\n\n    &.disabled {\n      color: #e0e0e0;\n      cursor: not-allowed;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Toggle-module__font-s-10___Le7nW`,
	"fontS12": `Toggle-module__font-s-12___vxstX`,
	"fontS13": `Toggle-module__font-s-13___CThxk`,
	"fontS14": `Toggle-module__font-s-14___h83kj`,
	"fontS15": `Toggle-module__font-s-15___PlKJ9`,
	"fontS16": `Toggle-module__font-s-16___Iz7vV`,
	"fontS18": `Toggle-module__font-s-18___cqcHW`,
	"fontS20": `Toggle-module__font-s-20___q5uxa`,
	"fontS22": `Toggle-module__font-s-22___F7fes`,
	"fontS28": `Toggle-module__font-s-28___Ul1g2`,
	"fontW400": `Toggle-module__font-w-400___bvFAW`,
	"fontW500": `Toggle-module__font-w-500___ANR97`,
	"fontW600": `Toggle-module__font-w-600___w0H0V`,
	"fontW700": `Toggle-module__font-w-700___GuOX3`,
	"p5": `Toggle-module__p-5___bElxc`,
	"p12": `Toggle-module__p-12___utceG`,
	"p16": `Toggle-module__p-16___pp3J5`,
	"p30": `Toggle-module__p-30___ura9N`,
	"pB0": `Toggle-module__p-b-0___fOkDD`,
	"pB5": `Toggle-module__p-b-5___U1WJv`,
	"pB10": `Toggle-module__p-b-10___cu6ux`,
	"pB12": `Toggle-module__p-b-12___hlgkc`,
	"pB16": `Toggle-module__p-b-16___es_tH`,
	"pB18": `Toggle-module__p-b-18___cw0GX`,
	"pB20": `Toggle-module__p-b-20___VQq19`,
	"pB25": `Toggle-module__p-b-25___dy7Re`,
	"pB30": `Toggle-module__p-b-30___seXm3`,
	"pB50": `Toggle-module__p-b-50___rYEXp`,
	"pT0": `Toggle-module__p-t-0___VFs8l`,
	"pT12": `Toggle-module__p-t-12___gAQ6H`,
	"pT16": `Toggle-module__p-t-16____QPa9`,
	"pT18": `Toggle-module__p-t-18___Bxxy6`,
	"pT20": `Toggle-module__p-t-20___SfsSk`,
	"pT30": `Toggle-module__p-t-30___DlkPV`,
	"pT40": `Toggle-module__p-t-40___X1RhJ`,
	"pT50": `Toggle-module__p-t-50___o1A4X`,
	"pL20": `Toggle-module__p-l-20___m4JHU`,
	"pL30": `Toggle-module__p-l-30___eTUxK`,
	"pL40": `Toggle-module__p-l-40___Xd4uV`,
	"pR16": `Toggle-module__p-r-16___Y7O4J`,
	"pR20": `Toggle-module__p-r-20___hKVlB`,
	"pR30": `Toggle-module__p-r-30___cYkmP`,
	"pR50": `Toggle-module__p-r-50___In3dU`,
	"pR60": `Toggle-module__p-r-60___UhoHj`,
	"mB1": `Toggle-module__m-b-1___Yg_Pg`,
	"mB2": `Toggle-module__m-b-2___X062S`,
	"mB6": `Toggle-module__m-b-6___Gv0Qi`,
	"mB8": `Toggle-module__m-b-8___mKuC3`,
	"mB10": `Toggle-module__m-b-10___bHhPx`,
	"mB14": `Toggle-module__m-b-14___QZY99`,
	"mB16": `Toggle-module__m-b-16___m969T`,
	"mB20": `Toggle-module__m-b-20___sUNTm`,
	"mB22": `Toggle-module__m-b-22___pdwGn`,
	"mB24": `Toggle-module__m-b-24___S1KTn`,
	"mB30": `Toggle-module__m-b-30___JZqL7`,
	"mB32": `Toggle-module__m-b-32___DzFb9`,
	"mB40": `Toggle-module__m-b-40___DZpzt`,
	"mT2": `Toggle-module__m-t-2___FZtJj`,
	"mT3": `Toggle-module__m-t-3___d9PGh`,
	"mT4": `Toggle-module__m-t-4___pNeCc`,
	"mT5": `Toggle-module__m-t-5___ywVOq`,
	"mT8": `Toggle-module__m-t-8___vPMqz`,
	"mT10": `Toggle-module__m-t-10___ln6it`,
	"mT15": `Toggle-module__m-t-15___zsdtD`,
	"mT16": `Toggle-module__m-t-16___dWpYO`,
	"mT20": `Toggle-module__m-t-20___VTQ5L`,
	"mT22": `Toggle-module__m-t-22___jfxZG`,
	"mT30": `Toggle-module__m-t-30___PnoX1`,
	"mT32": `Toggle-module__m-t-32___zruil`,
	"mLAuto": `Toggle-module__m-l-auto___xP1TU`,
	"mL4": `Toggle-module__m-l-4___iIC6Z`,
	"mL5": `Toggle-module__m-l-5___EdmJW`,
	"mL6": `Toggle-module__m-l-6___dalWi`,
	"mL8": `Toggle-module__m-l-8____cISB`,
	"mL10": `Toggle-module__m-l-10___ZFsvg`,
	"mL16": `Toggle-module__m-l-16___ZRQRI`,
	"mL20": `Toggle-module__m-l-20___gWdkC`,
	"mL24": `Toggle-module__m-l-24___e_s9D`,
	"mL30": `Toggle-module__m-l-30___XFQpW`,
	"mL35": `Toggle-module__m-l-35___LQG0A`,
	"mL40": `Toggle-module__m-l-40___wWmot`,
	"mR8": `Toggle-module__m-r-8___Kk1lM`,
	"mR10": `Toggle-module__m-r-10___ezhHo`,
	"mR16": `Toggle-module__m-r-16___xgh_e`,
	"mR20": `Toggle-module__m-r-20___OEnNc`,
	"mR24": `Toggle-module__m-r-24___pnT_O`,
	"mR30": `Toggle-module__m-r-30____6YtL`,
	"mR40": `Toggle-module__m-r-40___UfYCQ`,
	"borderR3": `Toggle-module__border-r-3___kysXw`,
	"borderR4": `Toggle-module__border-r-4___Ew85T`,
	"borderR6": `Toggle-module__border-r-6___WuGKL`,
	"borderR10": `Toggle-module__border-r-10____cou_`,
	"borderR12": `Toggle-module__border-r-12___oMxfH`,
	"borderR16": `Toggle-module__border-r-16___PCmtx`,
	"borderR50": `Toggle-module__border-r-50___ND1ZC`,
	"primaryBorder": `Toggle-module__primary-border___aoRw9`,
	"primaryBorderB": `Toggle-module__primary-border-b___GKOHz`,
	"primaryBorderT": `Toggle-module__primary-border-t___eSEJD`,
	"primaryBorderL": `Toggle-module__primary-border-l___pEcmj`,
	"primaryBorderR": `Toggle-module__primary-border-r___z4ZxM`,
	"secondaryBorder": `Toggle-module__secondary-border___Z3ldy`,
	"secondaryBorderB": `Toggle-module__secondary-border-b___EW9Gy`,
	"secondaryBorderT": `Toggle-module__secondary-border-t___GH1on`,
	"secondaryBorderL": `Toggle-module__secondary-border-l___OTB8w`,
	"secondaryBorderR": `Toggle-module__secondary-border-r___jC2rO`,
	"gap0": `Toggle-module__gap-0___OY0RS`,
	"gap2": `Toggle-module__gap-2___rlLrM`,
	"gap4": `Toggle-module__gap-4___ZJFzy`,
	"gap5": `Toggle-module__gap-5___baqPM`,
	"gap6": `Toggle-module__gap-6___gYOp4`,
	"gap8": `Toggle-module__gap-8___a12cl`,
	"gap10": `Toggle-module__gap-10____lBMv`,
	"gap12": `Toggle-module__gap-12___BHsGw`,
	"gap14": `Toggle-module__gap-14___vbP7m`,
	"gap16": `Toggle-module__gap-16___mvWGv`,
	"gap18": `Toggle-module__gap-18___nbpyr`,
	"gap20": `Toggle-module__gap-20___hRkp2`,
	"gap24": `Toggle-module__gap-24___OlQtW`,
	"gap26": `Toggle-module__gap-26____yiiE`,
	"gap30": `Toggle-module__gap-30___vkTzm`,
	"gap32": `Toggle-module__gap-32___VhNZj`,
	"gap40": `Toggle-module__gap-40___HYSMP`,
	"gap50": `Toggle-module__gap-50___Y8p88`,
	"flex1": `Toggle-module__flex-1____nqaV`,
	"flexNone": `Toggle-module__flex-none___MncPn`,
	"flexColumn": `Toggle-module__flex-column____S2pi`,
	"flexRow": `Toggle-module__flex-row___Ht28M`,
	"verticallyCentered": `Toggle-module__vertically-centered___SFxbV`,
	"horizontallyCentered": `Toggle-module__horizontally-centered___UugwM`,
	"horizontallyEnd": `Toggle-module__horizontally-end___qku_8`,
	"verticallyStart": `Toggle-module__vertically-start___o003d`,
	"spaceBetween": `Toggle-module__space-between___ErWR9`,
	"flexWrap": `Toggle-module__flex-wrap___4OvI4`,
	"height100": `Toggle-module__height-100___AwQzE`,
	"width50": `Toggle-module__width-50___a96jM`,
	"width100": `Toggle-module__width-100___BvR2U`,
	"cursorPointer": `Toggle-module__cursor-pointer___BjJqB`,
	"cursorNotAllowed": `Toggle-module__cursor-not-allowed___xzx9e`,
	"absoluteCentered": `Toggle-module__absolute-centered___EUiCK`,
	"absolute": `Toggle-module__absolute___Ogcik`,
	"relative": `Toggle-module__relative___mk108`,
	"fixed": `Toggle-module__fixed___BG8EP`,
	"visible": `Toggle-module__visible___ZATHy`,
	"invisible": `Toggle-module__invisible___eys89`,
	"col90": `Toggle-module__col-90___EoiAR`,
	"colAuto": `Toggle-module__col-auto___lEI55`,
	"medicalTabs": `Toggle-module__medical-tabs___ITle8`,
	"medicalTableNew": `Toggle-module__medical-table-new___KgcIC`,
	"noPagination": `Toggle-module__no-pagination___GI39W`,
	"medicalTableEmpty": `Toggle-module__medical-table-empty___oVW8s`,
	"iconBtn": `Toggle-module__icon-btn___j8_V_`,
	"searchIcon": `Toggle-module__search-icon___K34C7`,
	"disableSelect": `Toggle-module__disable-select___yNGaV`,
	"breakWord": `Toggle-module__break-word___bS41Q`,
	"popupClearBtn": `Toggle-module__popup-clear-btn___U4BiZ`,
	"scrollMB20": `Toggle-module__scroll-m-b-20___skioI`,
	"container": `Toggle-module__container___SvOpR`,
	"option": `Toggle-module__option___BXq3o`,
	"small": `Toggle-module__small___PtjgC`,
	"selected": `Toggle-module__selected___K1v1C`,
	"disabled": `Toggle-module__disabled___y4P1T`
};
module.exports = ___CSS_LOADER_EXPORT___;
